export default __webpack_public_path__ + "media/images/Collapse_Right-f2448aba816a1e1e0a1c00d6fa987f07.png";